"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OverlayTrigger = exports.OverlayTriggerContext = void 0;

var react_1 = __importStar(require("react"));

var overlays_1 = require("@react-aria/overlays");

var overlays_2 = require("@react-stately/overlays");

var react_2 = require("react");

exports.OverlayTriggerContext = (0, react_2.createContext)({});

function OverlayTrigger(props) {
  var children = props.children;
  var triggerRef = (0, react_1.useRef)(null);
  var overlayRef = (0, react_1.useRef)(null);
  var state = (0, overlays_2.useOverlayTriggerState)(props);

  var _a = (0, overlays_1.useOverlayTrigger)(props, state, triggerRef),
      triggerProps = _a.triggerProps,
      overlayProps = _a.overlayProps;

  return react_1.default.createElement(react_1.default.Fragment, null, children({
    state: state,
    triggerProps: triggerProps,
    overlayProps: overlayProps,
    triggerRef: triggerRef,
    overlayRef: overlayRef
  }));
}

exports.OverlayTrigger = OverlayTrigger;